import React from 'react'
import Banquets from "../images/banquets.jpg";
import banquethall from "../images/banqeut30people.jpg"
import Banquetparty from "../images/banquet.jpg"

function Banquethall() {
  return (
    <div>
        <div id="carouselExampleDark" className="carousel carousel-dark slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div className="carousel-inner">
    <div className="carousel-item active" data-bs-interval="10000">
      <img src={Banquets} className="d-block w-100" alt="rannabati"/>
      <div className="carousel-caption d-none d-md-block">
        <h3 style={{color:"white"}}>Banquet Hall</h3>
        <p style={{color:"white"}}>64,R.N Tagore Road, High Street, Krishnanagar, Pin-741101, Dist- Nadia
Time: 8am – 11pm (Everyday).</p>
      </div>
    </div>
    <div className="carousel-item" data-bs-interval="2000">
      <img src={banquethall} className="d-block w-100" alt="rannabati"/>
      <div className="carousel-caption d-none d-md-block">
      <h3 style={{color:"white"}}>Banquet Hall</h3>
        <p style={{color:"white"}}>64,R.N Tagore Road, High Street, Krishnanagar, Pin-741101, Dist- Nadia
Time: 8am – 11pm (Everyday).</p>
      </div>
    </div>
    <div className="carousel-item">
      <img src={Banquetparty} className="d-block w-100" alt="rannabati"/>
      <div className="carousel-caption d-none d-md-block">
      <h3 style={{color:"white"}}>Banquet Hall</h3>
        <p style={{color:"white"}}>64,R.N Tagore Road, High Street, Krishnanagar, Pin-741101, Dist- Nadia
Time: 8am – 11pm (Everyday).</p>
      </div>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Banquethall